function isFunction(obj) {
    return obj && typeof obj === "function" && typeof obj.nodeType !== "number"
}


function getUrlQueryParams(url) {
    var params = {};
    var regex = /[\?&]([a-zA-Z_]+)=([\w\-\.]*)/g;
    var results
    while ((results = regex.exec(url)) != null) {
        params[results[1]] = results[2];
    }
    return params;
}

function getServletUrl(uri) {

    var url = uri
    if (url.indexOf('/mmf-web/') > 0) {
        url = url.substring(url.indexOf('/mmf-web/')+8)
    }
    //将超链接的参数部分滤掉 ?xxx
    if (url.indexOf('?') > 0) {
        url = url.substring(0, url.indexOf('?'));
    }
    return url
}

//取页面的title与导航信息
function getMenuTitleData(caller) {
    console.log("caller.$route.query.menuId is :", caller.$route.query.menuId)
    console.log("caller.$route.path is :", caller.$route.path)
    let actionName = "";
    let actionParam = {};
    //有this.$route.query.menuId就按menuId查
    if (caller.$route.query.menuId) {
        actionName = "api/get";
        actionParam = {
            url:
                process.env.VUE_APP_EM_ADMIN_URL +
                "/emMenu/menuTitleData/" +
                caller.$route.query.menuId
        };
    }
    // 没有就按path+crudState查，crudState可为空
    else if (caller.$route.path) {
        actionName = "api/post";
        actionParam = {
            url: process.env.VUE_APP_EM_ADMIN_URL + "/emMenu/menuTitleData",
            data: {
                url: caller.$route.path,
                crudState: caller.crudState
            }
        };
    }
    console.log("log >>> actionName is ", actionName)
    if (actionName != "") {
        console.log("log >>> enter dispatch with", JSON.stringify(actionParam))
        caller.$store
            .dispatch(actionName, actionParam, {root: true})
            .then(menuTitleData => {
                // todo : api中get返回的是response.data而post则直接返回response，所以需要再取一下data，不知道这样区分又何必要。将来看怎么统一一下
                if (actionName == "api/post") {
                    menuTitleData = menuTitleData.data
                }
                caller.menuTitleData = menuTitleData
                alert("赋值完毕：" + JSON.stringify(caller.menuTitleData))
            });
    }
}

function getCloneFilter({context,entity, filterState = 'filter', withPagination = true} = {}) {
    let cloneFilter = {}
    //如果需要分页，就合并分页条件
    if (withPagination) {
        cloneFilter = Object.assign({}, context.rootState[entity].fixedFilter, context.rootState[entity][filterState])
    } else {
        cloneFilter = Object.assign({}, context.rootState[entity][filterState])
    }
    //removing empty fileds
    for (let key in cloneFilter)
        if (cloneFilter.hasOwnProperty(key) && cloneFilter[key] === "") delete cloneFilter[key]
    return cloneFilter
}

/**
 * 转换首字母大写，不会修改原字符串
 * @param str
 * @returns {*}
 */
function toCapFirst(str) {
    return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
}
/**
 * 转换首字母小写，不会修改原字符串
 * @param str
 * @returns {*}
 */
function toUncapFirst(str) {
    return str.replace(/( |^)[A-Z]/g, (L) => L.toLowerCase());
}
export default {
    getMenuTitleData,
    isFunction,
    getUrlQueryParams,
    getServletUrl,
    toCapFirst,
    toUncapFirst,
    getCloneFilter
} 